export default __webpack_public_path__ + "static/media/descargar.8a88f21d.svg";